'use strict';

var FaresAverageGridDirective = function FaresAverageGridDirective() {
  return {
    template: require('../templates/fares-average-grid.html'),
    restrict: 'E',
    controller: 'FaresAverageGridController',
    scope: {
      brushFilterChanged: '=',
      screenState: '='
    },
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        var filter = $scope.gridRowSelected(selectedRows);
        $scope.brushFilterChanged(filter);
      });
      $scope.$on('fares-average-data-grid:saveChanges', $scope.saveFares);
    }
  };
};
FaresAverageGridDirective.$inject = [];
module.exports = FaresAverageGridDirective;